import { canUseDOM } from "exenv";
import isPlainObject from "lodash/isPlainObject";
import getEmojiRegex from "emoji-regex";

const toString = Object.prototype.toString;

const isArray = Array.isArray;
export const isNumber = value => typeof value === "number";
export const isObject = o => toString.call(o) === "[object Object]";
export const isFunction = fn => typeof fn === "function";

// @see http://www.jstips.co/zh_cn/create-range-0...n-easily-using-one-line/
// IE9 不支持 Array.from
export function range(...args) {
  let [start, end, step] = [0, 0, 1];
  if (args.length === 1) {
    end = args[0];
  } else if (args.length === 2) {
    [start, end] = args;
  } else {
    [start, end, step] = args;
  }
  return Array.apply(null, { length: end - start }).map((v, i) => args[0] + i * step * step); // eslint-disable-line
}

export function keyMirror(o) {
  const mirror = {};
  if (isArray(o)) {
    o.forEach(i => i && (mirror[i] = i));
  } else if (isObject(o)) {
    for (const k in o) {
      o.hasOwnProperty(k) && mirror[k] === k;
    }
  }
  return mirror;
}

export function objectEvery(object, check) {
  if (!object) return true;
  for (const key in object) {
    if (!object.hasOwnProperty || object.hasOwnProperty(key)) {
      const value = object[key];
      if (isPlainObject(value)) {
        if (objectEvery(value, check) === false) {
          return false;
        }
      } else if (check(value, key) === false) {
        return false;
      }
    }
  }
  return true;
}

export const canUseURL = canUseDOM && window && window.URL && typeof window.URL.createObjectURL === "function";

export function getFilesFromElement(el) {
  try {
    // may be fail in old ie
    return el.files;
  } catch (e) {
    // noop
  }
}

export function getImageSizeFromInput(input, fn) {
  const images = getFilesFromElement(input);
  const sizes = [];
  if (images && canUseURL) {
    let L = images.length;
    Array.from(images).forEach(img => {
      const imgEl = new Image();
      imgEl.onload = () => {
        const { width, height } = imgEl;
        sizes.push({ width, height, size: img.size, image: img });
        --L === 0 ? fn(sizes) : void 0;
        window.URL.revokeObjectURL(imgEl.src);
      };
      imgEl.src = window.URL.createObjectURL(img);
    });
  } else {
    // IE9: only single file supports
    input.select();
    input.blur();
    const src = document.selection.createRange().text;
    const imgEl = new Image();
    imgEl.className = "ie-image-size-proxy";
    document.body.appendChild(imgEl);
    try {
      imgEl.filters.item("DXImageTransform.Microsoft.AlphaImageLoader").src = src;
    } catch (e) {
      void 0;
    }
    const { offsetWidth, offsetHeight } = imgEl;
    fn([{ width: offsetWidth, height: offsetHeight }]);
    document.body.removeChild(imgEl);
  }
}

const random = Math.random;
export const g = prefix =>
  `${prefix || ""}_${random()
    .toString(36)
    .slice(2)}`;

export const canUseFormData = canUseDOM && typeof window.FormData === "function";

export const IFRAME_DEFAULT_SRC =
  canUseDOM && /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank"; // eslint-disable-line

export function dropEmoji(text) {
  if (text) {
    return text.replace(new RegExp(getEmojiRegex, "g"), "");
  }
  return text;
}

function camelToHythen(s) {
  // 全转小写，你要大写干嘛呢是吧
  return `${s}`.replace(/[A-Z]/g, "-$&").toLowerCase();
}

export function dataset(dom, key) {
  return dom.dataset ? dom.dataset[key] : dom.getAttribute(`data-${camelToHythen(key)}`);
}

/**
 * 替换文本开头的全角人民币符号为半角人民币符号+空格
 * @param {String} text
 * @return {String}
 */
export function leadingFullWidthYenToHalf(text) {
  if (!text) return text;
  return text.replace(/^\uffe5/g, "\u00a5 ");
}

export function closestId(el, context) {
  if (!context) context = document.documentElement;
  if (!isFunction(context.getAttribute) || (el && !isFunction(el.getAttribute))) {
    throw "closestId: need an element as the first/ second argument or no second";
  }
  let id;
  while (el !== context && !(id = el.getAttribute("data-id"))) el = el.parentNode;
  return { id, el };
}

export function zeroism(num, digits = 2) {
  let a;
  return (a = new Array(digits)).push(num), a.join("0").slice(-digits);
}

/**
 *
 * @param be
 * @param modifiers
 */
export function bemClassNames(be, modifiers) {
  return modifiers.reduce(
    function(map, prop) {
      // eslint-disable-line
      map[`${be}--${prop}`] = prop; // eslint-disable-line
      return map;
    },
    {
      [be]: be,
    }
  );
}
